import { useState } from 'react';

import QRCode from 'react-qr-code';

import { PropsFromInputs } from '../../types';

import { BG_COLOR, Container, FG_COLOR } from './layout';
import Overlay from './Overlay';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ link = '', size = 256 }: Props) => {
  // Pour mesurer le nombre de pixel du QR Code
  const [pixels, setPixels] = useState<number>();
  const handleReady = (node: HTMLAnchorElement | null) => {
    const svgNode = node?.querySelector('svg');
    const viewBox = svgNode?.getAttribute('viewBox');
    const value = viewBox?.split(' ').pop();
    setPixels(value?.match(/^\d+$/) ? +value : undefined);
  };

  // Les dimensions de container
  const style = { width: size, height: size };

  return (
    <Container ref={handleReady} href={link} style={style} aria-busy={!pixels}>
      <QRCode value={link} bgColor={BG_COLOR} fgColor={FG_COLOR} />
      {pixels ? <Overlay size={pixels} color={BG_COLOR} /> : null}
    </Container>
  );
};
